export const tiktokPixel = (event, props = null) => {

    if (typeof window !== "undefined") {
        if (window.ttq != null) {

            if (props) {
                ttq.track(event, props)
            } else {
                ttq.track(event)
            }

        }
    }

}
